// @flow
import styled from "styled-components";

import colors from '../../assets/css/colors';

export const AdsContainer = styled.div`
	background:${colors.lightGreen};
	padding: 20px;
	width: 100%;
	min-height: 130px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export default AdsContainer;


// WEBPACK FOOTER //
// ./src/components/AdsContainer/index.js